var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CartItem } from "./CartItem";
var ExtraArticleCartItem = /** @class */ (function (_super) {
    __extends(ExtraArticleCartItem, _super);
    function ExtraArticleCartItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isExtraArticle = true;
        return _this;
    }
    Object.defineProperty(ExtraArticleCartItem.prototype, "quantity", {
        get: function () {
            var _a, _b, _c, _d;
            var fallbackValue = 0;
            var quantityLeft = this.priceModel.max_quantity_left;
            var parentQuantity = ((_b = (_a = this.dirtyParentItem) === null || _a === void 0 ? void 0 : _a.position) === null || _b === void 0 ? void 0 : _b.quantity) || "";
            var selectedQuantity = (((_d = (_c = this.dirtyCartItem) === null || _c === void 0 ? void 0 : _c.position) === null || _d === void 0 ? void 0 : _d.quantity) || "");
            selectedQuantity = Math.min(+selectedQuantity, +parentQuantity, quantityLeft);
            selectedQuantity = Math.max(selectedQuantity, fallbackValue);
            return String(selectedQuantity);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExtraArticleCartItem.prototype, "_booking", {
        get: function () {
            return {
                quantity: this.quantity,
                personal_data_index: this.personalDataIndex
            };
        },
        enumerable: false,
        configurable: true
    });
    return ExtraArticleCartItem;
}(CartItem));
export { ExtraArticleCartItem };
